export function sfTagsArrayToQuery(tags: string[]) {
  return tags.map((tag) => `tag:${tag}`).join(" OR ")
}
